import { React, createContext, useState, useContext, useEffect, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ApiService } from '../ApiService';
import { openDB, deleteDB } from 'idb';
import default_user from '../../images/user.png';
import default_picture from '../../images/default_img.png';
import default_cover from '../../images/banner-default.jpg';
import picture_loading from '../../images/Loading_icon.gif';
import CallApi from '../../data/CallApi';
import { returnCurrentDateTime, diferenciaFechas } from '../../utils/goblaFunctions';


const API_URL = process.env.REACT_APP_API_URL;

const AppContext = createContext();
export const useProovedorData = () => useContext(AppContext);

export const ProovedorData = ({ children }) => {
    const token_local = String(localStorage.getItem("token"));

    const { options, view } = useParams();
    const parametros = useParams();

    const params = new URLSearchParams(window.location.search);
    const visiteNit = params.get('search');

    const navigate = useNavigate();

    /////////////////////////DATA REF///////////////////////////////////

    ///////////////////////////////////////////////////////////////////
    const userVideoHistoryRef = useRef({});
    const vdRef = useRef({});
    const videosVistosRef = useRef([]);
    /////////////////////////STATES///////////////////////////////////
    const [showLogin, setShowLogin] = useState(false);

    const [data_user, setData_user] = useState({
        authCode: null,
        fullname: "Iniciar Sesion",
        perfil: null
    });

    const [videoData, setVideoData] = useState({});

    const [copyProduct, setCopyProduct] = useState({});
    //    {
    //         information:{},
    //         publications:{},
    //         curriculum:{},
    //         images:[],
    //         videos:[],
    //     }
    const [cacheDataUsers, setCacheDataUsers] = useState({});

    // const [cacheProductHosming, setCacheProductHosming] = useState({
    //     listProduct: [],
    //     infoPagination: {},
    //     search_result: {}
    // });
    const [shareDetected, setShareDetected] = useState({});

    const [oldResultsSearch, setOldResultsSearch] = useState({});

    const [cacheCompany, setCacheCompany] = useState({});

    const [requestServer, setRequestServer] = useState({
        status: false,
        pending_requests: 0
    });

    const [main_data, setMainData] = useState({
        publications: [],
        companys: [],
    });

    const [listCompanies, setListCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [globalLoaders, setGlobalLoaders] = useState({
        login: false
    });

    const [temporalNewCompany, setTemporalNewCompany] = useState({
        companyID: '',
        companyName: '',
        companyDescription: '',
        country: null,
        colorCompany: '#989d96',
        logoCompany: null,
        lis_branchs: [{
            fullName: `Local 1`,
            phone: '',
            lat: "-17.78356160586947",
            lon: "-63.180527126488954",
            city: null,
            text_direction: '',
            type: null,
            currency: null
        }]
    });

    const [dbData, setDbData] = useState(null);
    //////////////////////END STATES///////////////////////////////////
    const returnCurrency = (price = '0.00', type = 'BOB', onlyPrice = false) => {
        const numValue = parseFloat(price);
        if (isNaN(numValue)) return "";

        if (onlyPrice) {
            return new Intl.NumberFormat(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numValue);
        }

        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: type
        }).format(numValue);
    }

    const getTableInfo = (type) => {
        const objectTables = {
            companies: { exp: 'myCompanies', url: 'api/company/my', time: 60 },
            global: { exp: 'currencies', url: 'api/company/my', time: 300 },
        };
        return objectTables[type] ?? null;
    }
    /*
    https://www.fastforex.io/?gad_campaignid=18356270575
    
    https://p2p.binance.com/bapi/c2c/v2/friendly/c2c/adv/search
    {
        "asset": "USDT",
        "fiat": "BOB",
        "merchantCheck": false,
        "page": 1,
        "payTypes": [],
        "publisherType": null,
        "rows": 10,
        "tradeType": "SELL"
    }
    
    */
    async function loadDataLocal({ localDB = null, type = 'companies' }) {
        if (!localDB) return;
        const expName = getTableInfo(type);
        if (!expName) return;

        let companyExp = await localDB.get('expiration', expName.exp);

        const currentDT = returnCurrentDateTime();
        let updatePosts = false;

        if (companyExp) {
            const expirationDT = new Date(companyExp.Value);
            const newCurrentDT = new Date(currentDT);

            expirationDT.setMinutes(expirationDT.getMinutes() + expName.time);

            if (newCurrentDT > expirationDT) updatePosts = true;
        } else updatePosts = true;

        const getListCompanies = await localDB.get(type, 'my');
        let extractedResult;

        if (updatePosts || !getListCompanies || (getListCompanies && getListCompanies.Value.length == 0)) {
            await localDB.put('expiration', { id: expName.exp, Value: currentDT });

            const company_data = await CallApi({ url: expName.url });
            extractedResult = company_data ?? [];

            await localDB.put(type, { id: 'my', Value: extractedResult });
        } else {
            extractedResult = getListCompanies?.Value;
        }
        setMainData(data => ({ ...data, companys: extractedResult ?? [] }));
    }

    async function loadPrincipalData() {
        try {
            setLoading(true);

            if (data_user?.authCode == null) {
                const data = await ApiService.fetchData("api/user/mydata");
                setData_user(data);
            }

            let tempDataDB = null;

            if (!dbData) {
                tempDataDB = await openDB('data-storage', 3, {
                    upgrade(db) {
                        if (!db.objectStoreNames.contains('companies')) db.createObjectStore('companies', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('expiration')) db.createObjectStore('expiration', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('gallery')) db.createObjectStore('gallery', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('posts')) db.createObjectStore('posts', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('comments')) db.createObjectStore('comments', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('general')) db.createObjectStore('general', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('validTokens')) db.createObjectStore('validTokens', { keyPath: 'id' });
                    },
                });
            } else {
                tempDataDB = dbData;
            }

            if (tempDataDB) {
                await loadDataLocal({ localDB: tempDataDB, type: 'companies' });

            } else {
                console.info("No cargo tu base de datos pendejo");
            }
        } catch (error) {
            console.error("Surgio un error inesperado", error);
        } finally {
            setLoading(false);
        }
    }

    async function reloadMyCompanys() {
        try {
            setLoading(true);
            const company_data = await CallApi({
                url: "api/company/my"
            });
            setMainData(data => ({ ...data, companys: company_data ?? [] }));

            if (dbData) await dbData.put('companies', { id: 'my', Value: company_data });
        } catch (error) {
            console.error("Surgio un error inesperado", error);
        } finally {
            setLoading(false);
        }
    }

    const handleLogout = async () => {
        try {
            setGlobalLoaders((current_progress) => ({
                ...current_progress,
                login: true
            }));
            const response = await ApiService.fetchData('api/auth/logout', { method: 'POST' });
            if (response) {
                localStorage.clear();
                navigate('/login');

                userVideoHistoryRef.current = {};
                vdRef.current = {};

                cleanAllData();
            } else {
                console.error('Error al cerrar sesión: No se recibió respuesta del servidor.');
            }
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        } finally {
            setGlobalLoaders((current_progress) => ({
                ...current_progress,
                login: false
            }));
        }
    };

    const getNit = () => {
        const listParameters = String(parametros?.['*']).split("/");
        let nit = null;
        if (listParameters.length > 0 && listParameters[0] == 'administrar') nit = listParameters[listParameters.length - 1] ?? null;
        return nit;
    }

    const loadImageS = async (url, type = "profile") => {
        if (type === "wait" || url == null || !url) return getDefaultImage(type);

        try {
            const getUrl = String(url).split('/');
            const id = getUrl[getUrl.length - 1];

            let pruduct_local = sessionStorage.getItem(id);

            if (!pruduct_local) {
                let file_found = await dbData.get('gallery', id);

                if (!file_found) {
                    const response = await fetch(API_URL + url, {
                        mode: 'cors',
                        headers: {
                            'Authorization': 'Bearer ' + token_local
                        }
                    });

                    if (!response.ok) throw new Error('Error al descargar imagen');
                    const blob = await response.blob();

                    await dbData.put('gallery', { id, blob });
                    file_found = { id, blob };
                }

                pruduct_local = URL.createObjectURL(file_found?.blob);
                sessionStorage.setItem(id, pruduct_local);
            }

            return pruduct_local;
        } catch (error) {
            console.error(error);
            return getDefaultImage(type);
        }
    };

    const getDefaultImage = (type) => {
        switch (type) {
            case "profile": return default_user;
            case "picture": return default_picture;
            case "cover": return default_cover;
            case "wait": return picture_loading;
            default: return default_picture;
        }
    };

    async function cleanAllData() {
        setData_user({
            authCode: null,
            fullname: "cargando...",
            perfil: null
        });
        setCopyProduct({});
        setCacheDataUsers({});
        setOldResultsSearch({});
        setCacheCompany({});
        setRequestServer({
            status: false,
            pending_requests: 0
        });

        setMainData({
            publications: [],
            companys: [],
        });

        setListCompanies([]);
        setLoading(true);

        setTemporalNewCompany({
            companyID: '',
            companyName: '',
            companyDescription: '',
            country: null,
            colorCompany: '#989d96',
            logoCompany: null,
            lis_branchs: [{
                fullName: `Local 1`,
                phone: '',
                lat: "-17.78356160586947",
                lon: "-63.180527126488954",
                city: null,
                text_direction: '',
                type: null,
                currency: null
            }]
        });

        setShareDetected({});
        if (dbData) {
            await dbData.clear("companies");
            await dbData.clear("expiration");
            await dbData.clear("gallery");
            await dbData.clear("posts");
        }
    }

    useEffect(() => {
        sessionStorage.clear();

        const openImageDB = async () => {
            deleteDB('image-storage');

            const dbData = await openDB('data-storage', 3, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains('companies')) db.createObjectStore('companies', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('expiration')) db.createObjectStore('expiration', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('gallery')) db.createObjectStore('gallery', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('posts')) db.createObjectStore('posts', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('comments')) db.createObjectStore('comments', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('general')) db.createObjectStore('general', { keyPath: 'id' });
                    if (!db.objectStoreNames.contains('validTokens')) db.createObjectStore('validTokens', { keyPath: 'id' });
                },
            });

            setDbData(dbData);
        };

        openImageDB();
    }, []);

    useEffect(() => {
        // console.log(`Token:${token_local}\nCantidad de letras:${token_local.length}`)
        if (token_local.length > 90 && parametros['*'] != 'send-access') loadPrincipalData();
        else setLoading(false);
    }, [token_local]);

    useEffect(() => {
        const isTransfer = sessionStorage.getItem('extracted_data');
        const currentToken = String(localStorage.getItem("token"));

        if (currentToken.length > 150 && isTransfer && parametros['*'] != 'send-access') {
            navigate('send-access', { replace: true });
            setShareDetected(JSON.parse(isTransfer));
        }

        if ((parametros['*'] ?? "nada") == 'login') cleanAllData();
    }, [parametros]);

    return (
        <AppContext.Provider value={{
            loading,
            setLoading,
            data_user,
            setData_user,
            handleLogout,
            oldResultsSearch,
            setOldResultsSearch,
            requestServer,
            setRequestServer,
            cacheCompany,
            setCacheCompany,
            subPage: view ?? "products",
            main_data,
            setMainData,
            cacheDataUsers,
            setCacheDataUsers,
            copyProduct,
            setCopyProduct,
            listCompanies,
            setListCompanies,
            reloadMyCompanys,
            temporalNewCompany,
            setTemporalNewCompany,
            loadImageS,
            showLogin,
            setShowLogin,
            shareDetected,
            setShareDetected,
            token_local,
            dbData,
            globalLoaders,
            setGlobalLoaders,
            returnCurrency,
            diferenciaFechas,
            videoData,
            setVideoData,
            videoDataRef: vdRef.current,
            userVideos: userVideoHistoryRef.current,
            videosVistosRef
        }}>
            {children}
        </AppContext.Provider>
    )
}

//